import { useLang } from '../../../../../../hooks/use-lang';
import s from '../dashboard-external-monitoring.module.css';

export type HeatmapCategoryChip = { id: string; name: string };

type Props = {
  categories: HeatmapCategoryChip[];
  drillCategoryId: string | null;
  onSelectCategory: (categoryId: string) => void;
  onShowAll: () => void;
};

export const HeatmapCategoryFooter = ({
  categories,
  drillCategoryId,
  onSelectCategory,
  onShowAll,
}: Props) => {
  const { t } = useLang();

  return (
    <div className={s.heatmapDrillFooter}>
      <span className={s.heatmapDrillFooterLabel}>{t('Категории:')}</span>
      <div className={s.heatmapDrillFooterChips}>
        <button
          type="button"
          className={s.heatmapDrillChip}
          data-active={drillCategoryId == null ? true : undefined}
          onClick={onShowAll}
        >
          {t('Все категории')}
        </button>
        {categories.map((cat) => (
          <button
            key={cat.id}
            type="button"
            className={s.heatmapDrillChip}
            data-active={drillCategoryId === cat.id ? true : undefined}
            onClick={() => onSelectCategory(cat.id)}
          >
            {t(cat.name)}
          </button>
        ))}
      </div>
    </div>
  );
};
